import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getCurrentUser } from "../services/http/authService";

const ProtectedRoute = ({ path, component: Component, render, transportFormLoading, ...rest }) => {

  const isUserClinic = () => {
    const user = getCurrentUser();
    if (!user || user.superuser == true || user.lab_id) return false;
    return true;
  }

  return (
    <Route
      path={path}
      {...rest}
      render={props => {
        if (!isUserClinic())
          return (
            <Redirect
              to={{ pathname: "/sign-in", state: { from: props.location } }}
            />
          );
        return Component ? <Component {...props} transportFormLoading={transportFormLoading} /> : render(props);
      }}
    />
  );
};

export default ProtectedRoute;